import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms/forms';
import {DirectoryService} from '../../../services/directory.service';
import {ApiClientService} from '../../../services/api-client.service';
import {AccountPermissionsService} from '../../../services/account-permissions.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {Router} from '@angular/router';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'change-unit-modal',
    templateUrl: './change-unit-modal.component.html',
})

export class ChangeUnitModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showSpinner = false;
    moveInToBuildingId = null;
    moveInToSuiteId = null;
    buildingSelectIsDisabled = false;
    buildings: Array<any> = [];
    suites: Array<any> = [];

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService,
        private router: Router,
        public account: AccountPermissionsService,
        public urlService: UrlService,
    ) {}

    ngOnInit() {
        this.moveInToBuildingId = this.directoryService.changeUnitModalObject.buildingId;
        this.moveInToSuiteId = this.directoryService.changeUnitModalObject.suiteId;
        this.getBuildings();
        setTimeout( () => this.showModal = true, 300);
    }

    onSubmit(form: NgForm): void {
        if (!form.value.moveInToSuiteId) {
            toastr.warning('Suite should not be blank.');
            return;
        }
        this.disabledSubmit = true;
        const tabId = this.router.url.indexOf('lockers') != -1 ? 'lockers' : 'parking-spots';
        const url   = `${this.directoryService.directoryData[tabId].patch}${this.directoryService.changeUnitModalObject.id}`;
        const data = {
            building: this.moveInToBuildingId,
            suite:    this.moveInToSuiteId
        };
        this.api.patch('domainBD', url, data).subscribe(
            res => {
                this.disabledSubmit = false;
                toastr.success('Suite has been changed successfully.');
                this.directoryService.selectedItemData = null;
                this.directoryService.showDetailedView = false;
                if(this.router.url.indexOf('/directory/item/') == -1)
                    this.directoryService.getData();
                else
                    this.directoryService.onUnitChangeCompleted.emit();
                this.form.reset();
                this.hideModal(form);
            }, error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Failed to change the suite.')
            }
        );
    }

    hideModal(form) {
        if (form.dirty && form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.directoryService.isShowChangeUnitModal = false;
                    this.directoryService.changeUnitModalObject = null;
                }
            );
        } else {
            this.directoryService.isShowChangeUnitModal = false;
            this.directoryService.changeUnitModalObject = null;
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    changeBuilding(buildingId: string) {
        this.form.controls['moveInToSuiteId'].reset();
        this.getSuites(+buildingId);
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        this.buildingSelectIsDisabled = true;
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.buildings = JSON.parse(res._body).entities;
                this.buildingSelectIsDisabled = false;
                this.buildings = this.account.getBuildingsForUpdate(this.buildings, 'bldn');
                if(this.buildings.length === 1)
                    this.moveInToBuildingId = this.buildings[0].id;
                this.getSuites(this.moveInToBuildingId);
            },
            error => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    getSuites(buildingId: number): void {
        if (!buildingId) return;
        this.suites = [];
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.buildingSelectIsDisabled = false
        );
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/directory/change-unit-modal/change-unit-modal.component.ts